import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=caad720e&scoped=true&"
import script from "./SearchStudent.vue?vue&type=script&lang=js&"
export * from "./SearchStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caad720e",
  null
  
)

export default component.exports